// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"bac121c9","239":"591d84b1","533":"c1f68718","732":"79bba3be","765":"4d9c626b","914":"0bfbd165","963":"1c75f6e0","977":"f15641bd"}[chunkId] + ".chunk.js";
};